<template>
  <power-bi code="eyJrIjoiYWRiMWM5ZWEtNDNiZS00YTc2LTg1MmQtY2UxOGZhMzI0ZTJhIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../reports/components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
